import { IsString } from 'class-validator';

export class GetWorkerVm {
  @IsString()
  id: string;

  @IsString()
  name: string;

  @IsString()
  username: string;
}
